export type Region = "eu1";
export const regions: Region[] = ["eu1"];
